<template>
    <div>
        <div class="row justify-content-between align-items-center mt-5">
            <div class="col-sm-6 col-lg-3" v-html="text"></div>
            <div class="col-sm-6 col-lg-3">
                <select name="status" id="category" class="custom-select mb-4" v-model="activeCategory">
                    <option value="" selected>Selecteer categorie</option>
                    <option v-for="category in categories" :value="category">{{ category }}</option>
                </select>
            </div>
        </div>
        <div :class="{'show':item.active}" class="card card-toggle cursor-pointer"
             v-for="(item, index) in items"
             :key="index" @click="item.active = !item.active">
            <div class="card-body d-flex justify-content-between align-items-center">
                <h2>{{ item.title }}</h2>
                <i class="far fa-angle-down"></i>
            </div>
            <transition-slide-toggle>
                <div class="card-footer accordion-body" v-show="item.active">
                    <p v-html="item.antwoord"></p>
                </div>
            </transition-slide-toggle>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            text: String
        },
        data() {
            return {
                rawItems: [],
                items: [],
                categories: [],
                activeCategory: '',
            }
        },
        created() {

            let that = this;
            this.axios.get('/api/faq')
                .then(function (response) {
                    that.rawItems = _.map(response.data, function (element) {
                        return _.extend({}, element, {active: false});
                    });
                })
                .catch(function (error) {
                    console.log(error);
                })
                .then(function () {
                    that.items = that.rawItems;
                    that.categories = [...new Set(that.rawItems.map(item => item.category))];
                });
        },
        watch: {
            activeCategory: function (val) {
                if (val === '') {
                    this.items = this.rawItems;
                } else {
                    this.items = _.filter(this.rawItems, {'category': val});
                }
            }
        }

    }
</script>